import { render, staticRenderFns } from "./ListView.vue?vue&type=template&id=2f8f5822"
import script from "./ListView.ts?vue&type=script&lang=ts&external"
export * from "./ListView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports